import { MARQUEE_ITEMS } from "@/data/site";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="border-y border-gray-200 bg-white overflow-hidden py-5" data-testid="tech-marquee">
      <div className="marquee-track flex items-center gap-10 w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-mono text-sm uppercase tracking-[0.18em] text-gray-500 whitespace-nowrap">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-cobalt shrink-0" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};
